import {css} from 'lit';
export const styles = css`/* Currently this style is only use on BU project as on XS we are using xs-chat-list-item with its own style */

:host {
  --chat-list-item-color: var(--dark-text-secondary);
  --chat-list-item-bg: var(--contrast-light);
  --chat-list-item-font-size: 12px;
  --chat-list-item-title-color: var(--primary);
  --chat-list-item-title-font-size: 16px;
  --chat-list-item-title-font-weight: 700;
  --chat-list-item-border-width: 0;
  --chat-list-item-border-color: transparent;
  --chat-list-item-border-radius: 4px;
  --chat-list-item-unread-bg: var(--secondary);
  --dot-menu-trigger-width: 0;
  --dot-menu-trigger-height: 22px;
  --dot-menu-trigger-padding: 0;
  --dot-menu-trigger-border: none;
  --dot-menu-trigger-radius: 4px;
  --dot-menu-trigger-bg: var(--contrast-light);
  --dot-menu-trigger-bg-hover: var(--gray-100);
  --dot-menu-trigger-bg-active: var(--contrast-light);
  --dot-menu-trigger-color: var(--dark-text);
  --dot-menu-trigger-color-hover: var(--dark-text);
  --dot-menu-trigger-color-active: var(--dark-text);
}

slot[name='avatar']::slotted(*) {
  margin-right: 16px;
  color: var(--dark-text);
}

.content {
  display: flex;
  align-items: center;
  min-height: 75px;
  padding: 8px 12px;
  color: var(--chat-list-item-color);
  background-color: var(--chat-list-item-bg);
  font-size: var(--chat-list-item-font-size);
  border-width: var(--chat-list-item-border-width);
  border-color: var(--chat-list-item-border-color);
  border-style: solid;
  border-radius: var(--chat-list-item-border-radius);
  transition-property: background-color;
  transition-duration: var(--transition-duration);
  transition-timing-function: var(--transition-timing);
  cursor: pointer;
}

@media (max-width: 767px) {

.content {
    -webkit-user-select: none;
            user-select: none
}
  }

.content.unread .message {
  padding-right: 48px;
}

.info {
  min-width: 1px;
  flex: 1;
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.title {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-top: 0;
  margin-bottom: 0;
  font-weight: var(--chat-list-item-title-font-weight);
  font-size: var(--chat-list-item-title-font-size);
  color: var(--chat-list-item-title-color);
}

.date {
  white-space: nowrap;
}

.message {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.3em;
  margin-top: 4px;
  word-break: break-word;
}

.message.deleted .message-body {
  font-style: italic;
}

.unread-count {
  opacity: 0;
  position: absolute;
  right: 0;
  bottom: 0;
  padding: 4px 8px;
  background: var(--chat-list-item-unread-bg);
  color: #fff;
  border-top-left-radius: 4px;
  font-size: 0.78em;
  font-weight: 600;
  line-height: 1.2em;
  transition: opacity ease 0.2s;
}

.unread-count.visible {
  opacity: 1;
}

nav {
  position: absolute;
  top: 4px;
  right: 4px;
  z-index: 999;
}

:host([menuOpen]) {
  --dot-menu-trigger-width: 32px;

  z-index: 1; /* Increase z-Index on menu open so that menu would be above below items */
}

:host(.focus-visible) {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: -4px;
}

:host(:focus-visible) {
  outline: 1px solid var(--link-focus-outline);
  outline-offset: -4px;
}

@media (hover: hover) {
  :host(:hover) {
    --chat-list-item-bg: var(--gray-200);
    --dot-menu-trigger-width: 32px;
  }
}

:host(:active) {
  --chat-list-item-bg: var(--gray-300);
}

:host([mute]) {
  --chat-list-item-unread-bg: var(--gray-600);
}

:host([active]) {
  --chat-list-item-bg: var(--primary);
  --chat-list-item-title-color: var(--contrast-light);
  --chat-list-item-color: var(--contrast-light);
}
`;
export default styles;
